<div class="modal-inner resettle-options">
    <h1>Opnieuw verrekenen</h1>

    <p class="intro">
        {{ scopeLabel }} wordt opnieuw doorgerekend. Er wordt nog niets gewijzigd: je krijgt eerst de verschillen te
        zien.
    </p>

    <div class="option">
        <div class="option-label">Bestaande reisuren en kosten opnieuw verrekenen</div>

        <mat-radio-group [(ngModel)]="recalculateTravel">
            <mat-radio-button [value]="true">Ja</mat-radio-button>
            <mat-radio-button [value]="false">Nee</mat-radio-button>
        </mat-radio-group>

        <p class="option-help">
            @if (recalculateTravel) {
                Reisuren en reiskosten worden opnieuw verrekenen, ook op dagen waar ze al staan.<br />
                <i>
                    <b>Let op</b>
                    dit kan zorgen voor net andere afstanden in km's op bestaande regels van type RU/RUA/CRW
                </i>
            } @else {
                Dagen waar al reisuren of reiskosten staan blijven ongemoeid; alleen dagen zonder die uursoorten worden
                aangevuld.
            }
        </p>
    </div>

    <div class="buttons">
        <button class="planning-button cancel" mat-raised-button mat-dialog-close="">Annuleren</button>
        <button (click)="confirm()" class="planning-button confirm" color="primary" mat-raised-button>
            Doorrekenen
        </button>
    </div>
</div>
